import * as React from 'react'
import {Button, Dialog, 
        DialogTitle, DialogContent, 
        DialogActions, 
        IconButton, FormGroup, FormControlLabel, Checkbox, TextField,
        Typography} from '@mui/material'
import SmsIcon from '@mui/icons-material/Sms'
import CloseIcon from '@mui/icons-material/Close'
import { styled } from '@mui/material/styles'
import axios from 'axios';
import { axiosErrorHandling } from '../misc/other'


const CustomDialog = styled(Dialog)(({theme})=>({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
      },
      '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
      },
  
  }));

  export const SMSOptIn = ({customer_number, sms_opt_in,name, email, phone, open, onClose}) =>{

    const handleClose =() =>{
        onClose()
    }
    const [firstCheck, setFirstCheck] = React.useState(false)
    const [secondCheck, setSecondCheck] = React.useState(false)
    const [thirdCheck, setThirdCheck] = React.useState(false)
    const [buttonLabel, setButtonLabel] = React.useState('Opt In')
    const [buttonDisabled, setButtonDisabled] = React.useState(true)
    const [optIn, setOptIn] = React.useState(sms_opt_in)
    const [errorMessage, setErrorMessage] = React.useState('')

    const buttonClick = () =>{

        axios({
            method: 'POST',
            url: 'api/oracle3/smsoptin',
            data: {customer_number: customer_number,
                   opt_in: optIn 
            }
        }).then(res=>{
            if(res.data==='Opt In Updated'){
                onClose()
            }
        }).catch(err=>{
            let axiosErr =  axiosErrorHandling(err)
            setErrorMessage('Something went wrong: ', axiosErr)
            
        })

    }

    React.useLayoutEffect(()=>{

    if(firstCheck && secondCheck){
            setOptIn(1)
            setButtonLabel('Opt In')
            setButtonDisabled(false)
            
        }
        else if(thirdCheck){
            
        
        setOptIn(0)
        setButtonDisabled(false) 
        setButtonLabel('Opt Out')

        }

        else{
            setOptIn(0)
            setButtonLabel('Opt Out')
            setButtonDisabled(true)    
            
        }

            

    },[firstCheck, secondCheck, thirdCheck])
    
    
   const handlefirstChange = (event) =>{
        setFirstCheck(event.target.checked)
        setThirdCheck(false)

        

    }
  const  handleSecondChange = (event) =>{
        setSecondCheck(event.target.checked)
        setThirdCheck(false)
        

    }

 const handleThirdChange = (event) =>{
        setThirdCheck(event.target.checked)
        setFirstCheck(false)
        setSecondCheck(false)
        
         
    }


return(
    <CustomDialog open={open} onClose={handleClose}>
        <DialogTitle color='white' bgcolor='#C31200'  >
            SMS OPT IN
        </DialogTitle>
         <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
             <CloseIcon />
             </IconButton>
            <DialogContent dividers>
              <TextField sx={{mb: 1}}
              fullWidth
              id='name'
              label='Full Name'
              disabled
              defaultValue={name}/>
              <TextField
              sx={{mb: 1}}
              fullWidth 
              id='email'
              label='Email'
              disabled
              defaultValue={email}/>
              <TextField 
              sx={{mb: 1}}
              fullWidth 
              id='phone'
              label='Phone'
              disabled
              defaultValue={phone}/>
        <FormGroup>
              <FormControlLabel sx={{mb: 1}} control={<Checkbox checked={firstCheck} onChange={handlefirstChange}/>} label="Namemysettlement.com would like your consent to send text message communications from +18664656269 to your mobile number listed above, regarding customer care.
Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply 'STOP' to unsubscribe at any time. Reply 'HELP' for assistance or more information."/>
              <FormControlLabel sx={{mb: 1}} control={<Checkbox checked={secondCheck} onChange={handleSecondChange} />} label='Yes, I consent to receive informational messages from namemysettlement.com regarding customer care.' />
              <FormControlLabel sx={{mb: 1}} control={<Checkbox checked={thirdCheck} onChange={handleThirdChange}/>} label='No, I do not want to receive any text messages from namemysettlement.com'/>  
        </FormGroup>
            <Typography color='red' variant='body2' >***{errorMessage}</Typography>
            </DialogContent>
            <DialogActions>
            <Button variant='contained' disabled={buttonDisabled} endIcon={<SmsIcon />} onClick={buttonClick} >{buttonLabel}</Button>
            </DialogActions>      
    </CustomDialog>

)}